import { IntegrationApi } from '@alliander-fe/api';
import { useParams } from 'src/hooks/useParams';
import { useQuery } from '@tanstack/react-query';
import { rewriteEnergyType, setReplaceText } from 'src/utils';
import { OutageView } from './_View';
import { OutageSpecific } from './_OutageSpecific';
import { OutageNotFound } from './_OutageNotFound';

import { Props } from '.';

export function OutageGeneral(props: Props) {
  const { reference, postalCode, houseNumber, houseNumberAddition } = useParams();

  const { data, isLoading, isSuccess, isFetched } = useQuery({
    enabled: Boolean(reference),
    queryKey: ['specificOutage', reference],
    queryFn: () =>
      IntegrationApi.outagesEndpointsGetSpecificOutage({
        outageNumber: reference,
      }),
    select: (data) => {
      return {
        ...data,
        energyType: rewriteEnergyType(data.energyType),
      };
    },
  });

  if (!isFetched) return null;

  if (data && Object.values(data).filter(Boolean).length) {
    return (
      <OutageView {...props} outageData={data || {}} isSuccess={isSuccess} isLoading={isLoading} />
    );
  }

  // In case the reference number is wrong we try to fallback on the OutageSpecific.
  if (postalCode && houseNumber) {
    return (
      <OutageSpecific
        postalCode={postalCode}
        houseNumber={houseNumber}
        addition={houseNumberAddition}
        {...props}
      />
    );
  }

  const replaceText = {
    '{postalCode}': postalCode || '',
  };

  // Fallback when everything fails.
  return (
    <OutageNotFound
      notFoundText={setReplaceText(props.notFoundText?.toString() || '', replaceText)}
      notFoundTitle={setReplaceText(props.notFoundTitle?.toString() || '', replaceText)}
    />
  );
}
